<template>
  <div class="integralRecord">
    <md-tabs @change='changeTab'>
      <md-tab-pane class="content" name="0" label="审批中">
        <RecordList :list='detailList' :tags='tags'></RecordList>
      </md-tab-pane>
      <md-tab-pane class="content" name="1" label="未通过">
        <RecordList :list='detailList' :tags='tags'></RecordList>
      </md-tab-pane>
      <md-tab-pane class="content" name="2" label="已通过" >
        <RecordList :list='detailList' :tags='tags'></RecordList>
      </md-tab-pane>
    </md-tabs>
  </div>
</template>
<script>
import RecordList from '../../../components/recordList'
export default {
  name: "integralRecord",
  components:{ RecordList },
  data() {
    return {
      tags:'0',
      detailList:[],
      vipId:''
    };
  },
  mounted() {
    document.title = "积分记录";
    this.getListData(this.tags);
    this.vipId = JSON.parse(localStorage.getItem("userData")).cardAccount;
  },
  methods: {
    getListData(tags){
      
      this.$http.get('/sangto-wrm/vipScoreOther/getPhotoScore',{
          params:{
              startPosition: 0,
              maxResult: 100,
              vipId: this.vipId,
              stat: tags
          }
      }).then(({data})=>{
          if(data.code == 200 && data.data.rows){
              this.detailList = data.data.rows;
          }else{
              this.Toast.failed(data.message)
          }
      })
    },
    changeTab(e){
      this.tags = e.name;
      this.detailList = [];
      this.getListData(this.tags);
    },
  }
};
</script>
<style lang="scss" scoped>
.integralRecord {
  width:100%;
  height: 100vh;
}
</style>
